module.exports = __webpack_public_path__ + "static/media/cw.c945f032.svg";